import React from "react";
import cx from "classnames";
import styles from "./Pagination.module.scss";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../../components/interactions/Buttons/Button";

interface Props {
  setIndex: React.Dispatch<React.SetStateAction<number>>;
  index: number;
  count: number;
}

export const Pagination: React.FunctionComponent<Props> = ({
  setIndex,
  index,
  count,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(styles.pagination, "m-bottom-30", {
        [styles.hide]: count === 1,
      })}
    >
      <div className={cx(styles.uploads, "text-small")}>
        <b className="text-small">
          {t("Viewing file {{idx}} of {{total}}", {
            idx: index + 1,
            total: count,
          })}
        </b>
        <div>
          {[...Array(count)].map((_, i) => (
            <Button
              action
              key={i}
              className={cx(styles.pagination, "small", {
                [styles.active]: i === index,
              })}
              ghost={i !== index}
              onClick={() => setIndex(i)}
            >
              {i + 1}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
